export const pageConfig = {
  mediumJsonUrl: "http://localhost:3000/feed/get",
  githubJsonUrl: "http://localhost:3001/feed/get",
  maxArticles: 9,
  maxRepos: 12
};
